/* repo/customGroup*/
import { lensPath } from "ramda";
import {
  fetch as fetchApi,
  insert as insertApi,
  drop as dropApi,
  isString,
} from "./api";
import {
  CustomGroupCodec,
  CustomGroup,
  Data,
} from "../store/customGroup/types";
import { withDecoded, flattenData } from ".";

function mapToModel(data: object): CustomGroup {
  return withDecoded(CustomGroupCodec, data, (decoded) => ({
    ...decoded,
  }));
}

function mapToChageset(customGroup: Data): Data {
  return customGroup;
}

export async function fetch(
  id: string | null,
  params?: {}
): Promise<CustomGroup> {
  return fetchApi({
    nestedResourcePath: ["groups"],
    id: id,
    params: params,
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function save(customGroup: Data): Promise<CustomGroup> {
  return insertApi({
    nestedResourcePath: ["groups"],
    id: customGroup._id,
    data: { data: mapToChageset(customGroup) },
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function drop(id: string | null): Promise<boolean> {
  return dropApi({
    nestedResourcePath: ["groups"],
    id: id,
  }).then(() => true);
}
